import React from 'react'
import { Card, Row, Col } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const labels = [
  {
    label: 'Número Identificación',
    index: 'NoIdentificacion'
  },
  {
    label: 'Fracción Arancelaria',
    index: 'FraccionArancelaria',
  },
  {
    label: 'Valor en Dolares',
    index: 'ValorDolares',
  },
];

const ComplementoComercioExteriorMercanciasResumen = ({ data = {} }) => {

  const renderLeyends = (item) => {
    return (
      <SingleLeyendLabel
        key={ item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  return (
    <Card className="mb-2">
      <Card.Body>

      <Row>
        <Col>
          { labels.map(renderLeyends) }
        </Col>
      </Row>

      </Card.Body>
    </Card>
  )
}

export default ComplementoComercioExteriorMercanciasResumen;